import ResourcesUsagePage from './ResourcesUsagePage.vue';
import ResourcesUsageChart from './ResourcesUsageChart.vue';

export * from './types';
export {
    ResourcesUsagePage as default,
    ResourcesUsagePage,
    ResourcesUsageChart,
};
